import { graphql } from '__generated__';

import { useQueryStable } from '../useQueryStable';

// https://github.com/dbt-labs/codex-api/blob/main/schema.graphql
// https://github.com/dbt-labs/codex-api/blob/main/frontend/package.json#L33
// https://github.com/dbt-labs/codex-api/blob/main/frontend/codegen.yml
// generates: https://github.com/dbt-labs/codex-api/blob/main/frontend/src/typings/codex.ts
export const GetModelTestExecutionHistoryStatus = graphql(/* GraphQL */ `
  query ModelTestExecutionHistoryStatus(
    $environmentId: BigInt!
    $start: Date!
    $end: Date!
    $uniqueId: String!
  ) {
    performance(environmentId: $environmentId) {
      modelTestExecutionHistory(startDate: $start, endDate: $end, uniqueId: $uniqueId) {
        date
        executionFailOrErrorRate
        executionPassCount
        executionWarnCount
        executionFailCount
        executionErrorCount
      }
    }
  }
`);

type ModelTestExecutionHistoryParams = {
  environmentId?: number;
  startDate: string;
  endDate: string;
  uniqueId: string;
  pause?: boolean;
};

export const useModelTestExecutionHistoryStatus = ({
  environmentId = 0,
  startDate,
  endDate,
  uniqueId,
  pause,
}: ModelTestExecutionHistoryParams) => {
  const query = useQueryStable({
    query: GetModelTestExecutionHistoryStatus,
    variables: {
      environmentId,
      start: startDate,
      end: endDate,
      uniqueId,
    },
    pause: pause || !environmentId || !startDate || !endDate || !uniqueId,
  });

  // TODO: we need a cache invalidation strategy for performance endpoints

  return query;
};
